import React from 'react';
import { AkinatorCompletion } from 'types/suggestions';
import { akinatorCompletionsItems, akinatorCompletionsWrap } from './styles';
import { CompletionsAkinatorButton } from './completions-akinator-button';

type CompletionsAkinatorProps = {
  completions: AkinatorCompletion[];
  navigationIndex: number;
  onMouseEnter: (idx: number) => void;
  onMouseLeave: () => void;
  onCompletionClick: (completion: AkinatorCompletion) => void;
};

export const DATA_QA_COMPLETIONS_AKINATOR = 'completions-akinator';

export const CompletionsAkinator: React.FC<CompletionsAkinatorProps> = ({
  completions,
  navigationIndex,
  onMouseEnter,
  onMouseLeave,
  onCompletionClick,
}) => {
  return (
    <div className={akinatorCompletionsWrap} data-qa={DATA_QA_COMPLETIONS_AKINATOR}>
      <div className={akinatorCompletionsItems}>
        {completions.map((completion, elementIndex) => (
          <CompletionsAkinatorButton
            key={`${completion.name}_${completion.type}`}
            completion={completion}
            elementIndex={elementIndex}
            navigationIndex={navigationIndex}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            onCompletionClick={onCompletionClick}
          />
        ))}
      </div>
    </div>
  );
};
